import React from 'react';
import Header from './layout/Header';
import Footer from './layout/Footer';
import { GlobalStyle } from '../includes/style';

type LayoutProps = {
  children: React.ReactNode
};
export default function Layout({ children }:LayoutProps){
  return <>
    <GlobalStyle />
    <Header />
    <main id="content">{children}</main>
    <Footer />
  </>;
}
